// extracted by mini-css-extract-plugin
module.exports = {"root":"BtnFileBox_root__-Spmj","containerBtn":"BtnFileBox_containerBtn__rsput","btnCustom":"BtnFileBox_btnCustom__3xKYl"};